import type { ApiStripePublicKey, ApiStripeSecret } from './stripe.types';

export function extractSecret(res: ApiStripeSecret): string {
    return res.secret;
}

export function extractPublicKey(res: ApiStripePublicKey): string {
    return res.public_key;
}
